import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroCarousel from './components/HeroCarousel';
import ImpactMetrics from './components/ImpactMetrics';
import PresidentMessage from './components/PresidentMessage';
import TestimonialsSection from './components/TestimonialsSection';
import LeadershipDevelopmentSection from 'pages/about-heritage-vision/components/LeadershipDevelopmentSection';
import InstallationCelebration from './components/InstallationCelebration';

const Homepage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />

      {/* Hero Section with Carousel */}
      <HeroCarousel />

      {/* Impact Metrics Dashboard */}
      <ImpactMetrics />

      {/* 35th Installation Celebration */}
      <InstallationCelebration />

      {/* President's Message */}
      <PresidentMessage />

      {/* Live Activity Feed */}
      {/* <LiveActivityFeed /> */}

      {/* Member Spotlight */}
      {/* <MemberSpotlight /> */}

      {/* Membership Inquiry Portal */}
      {/* <MembershipInquiry /> */}

      {/* Upcoming Events */}
      {/* <UpcomingEvents /> */}


      <LeadershipDevelopmentSection />

      {/* Testimonials */}
      {/* <TestimonialsSection /> */}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Homepage;